import styled from 'styled-components';

export const InputHeader = styled.p`
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const StyledOption = styled.li`
  font-size: 16px;
`;
